export default "__VITE_ASSET__Bd1$ihtd__"